module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("479kN"))).then(() => parcelRequire('cvs7o'));